import nishthaMark from '../../assets/nishtha-leasing-mark.svg';

/** Match the public Nishtha website branding only on its own login host. */
export function LoginBrandMark({ hostname = window.location.hostname }: { hostname?: string }) {
  if (hostname.toLowerCase() === 'aura.nishthaleasing.in') {
    return (
      <div className="mx-auto flex flex-col items-center gap-3 text-center" style={{ marginBottom: 20 }} aria-label="Nishtha Leasing Private Limited">
        <img src={nishthaMark} alt="" width={56} height={56} className="h-14 w-14 shrink-0" />
        <div>
          <div className="text-xl font-semibold" style={{ color: '#0B1F3A', fontFamily: 'var(--ff-serif)' }}>Nishtha Leasing</div>
          <div className="mt-1 text-[11px] uppercase tracking-wider" style={{ color: 'var(--ink-3)' }}>Pvt Ltd · Since 1991</div>
        </div>
      </div>
    );
  }
  return (
    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl text-xl font-bold"
      style={{ background: 'linear-gradient(135deg, var(--ink-0), var(--ink-1))', color: 'var(--ivory-0)', fontFamily: 'var(--ff-serif)' }}>
      A
    </div>
  );
}
